
<template>
	<div :class="columnClass">

            <div v-if="columnLabel=='employee_name'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <div @click="onChangedSort('employee_name')" class="table_heading th_cell_1">
                    <!-- Name  -->
                    {{ sortType=='fname_asc' ? 'First Last' : 'Last, First'  }}
                    <span :class="(sortType=='fname_asc')?'fa fa-sort-asc fa-position':(sortType=='lname_asc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" aria-hidden="true"></span></div>
                </div>
            </div>

            <div v-if="columnLabel=='employee_seniority'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <div @click="onChangedSort('employee_seniority')" class="table_heading th_cell_2">Sen(Emp)<span :class="(sortType=='emp_seniority')?'fa fa-sort-asc fa-position':(sortType=='emp_seniority_desc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" aria-hidden="true"></span></div>
                </div>
            </div>

            <div v-if="columnLabel=='skill_seniority'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <div @click="onChangedSort('skill_seniority')" class="table_heading th_cell_2">Sen(Skill)<span :class="(sortType=='skill_seniority')?'fa fa-sort-asc fa-position':(sortType=='skill_seniority_desc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" aria-hidden="true"></span></div>
                </div>
            </div>

            <div v-if="columnLabel=='shift_count_ytd'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <div @click="onChangedSort('shift_count_ytd')" class="table_heading th_cell_4">Shift (YTD)<span :class="(sortType=='shift_YTD_asc')?'fa fa-sort-asc fa-position':(sortType=='shift_YTD_desc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" aria-hidden="true"></span></div>
                </div>
            </div>

            <div v-if="columnLabel=='shift_count_total'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <div @click="onChangedSort('shift_count_total')" class="table_heading th_cell_4">Shift (Total)<span :class="(sortType=='shift_total_asc')?'fa fa-sort-asc fa-position':(sortType=='shift_total_desc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" aria-hidden="true"></span></div>
                </div>
            </div>

            <div v-if="columnLabel=='shifts_this_week'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <div @click="onChangedSort('shifts_this_week')" class="table_heading th_cell_4">Shift (Week)<span :class="(sortType=='shift_weekly_asc')?'fa fa-sort-asc fa-position':(sortType=='shift_weekly_desc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" aria-hidden="true"></span></div>
                </div>
            </div>

            <div v-if="columnLabel=='shifts_ytd_july_june'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <div @click="onChangedSort('shifts_ytd_july_june')" class="table_heading th_cell_4">Shift (July-June)<span :class="(sortType=='shift_july_june_asc')?'fa fa-sort-asc fa-position':(sortType=='shift_july_june_desc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" aria-hidden="true"></span></div>
                </div>
            </div>

            <div v-if="columnLabel=='declines_total'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <div @click="onChangedSort('declines_total')" class="table_heading th_cell_4">Declines (Total)<span :class="(sortType=='decline_total__asc')?'fa fa-sort-asc fa-position':(sortType=='decline_total__desc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" aria-hidden="true"></span></div>
                </div>
            </div>

            <div v-if="columnLabel=='declines_ytd'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <div @click="onChangedSort('declines_ytd')" class="table_heading th_cell_4">Declines (YTD)<span :class="(sortType=='decline_YTD_asc')?'fa fa-sort-asc fa-position':(sortType=='decline_YTD_desc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" aria-hidden="true"></span></div>
                </div>
            </div>

            <div v-if="columnLabel=='declines_ytd_july_june'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <div @click="onChangedSort('declines_ytd_july_june')" class="table_heading th_cell_4">Declines (July-June)<span :class="(sortType=='decline_july_june_asc')?'fa fa-sort-asc fa-position':(sortType=='decline_july_june_desc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" aria-hidden="true"></span></div>
                </div>
            </div>

            <div v-if="columnLabel=='decline_this_week'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <div @click="onChangedSort('decline_this_week')" class="table_heading th_cell_4">Declines(Week)<span :class="(sortType=='decline_weekly_asc')?'fa fa-sort-asc fa-position':(sortType=='decline_weekly_desc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" aria-hidden="true"></span></div>
                </div>
            </div>

            <div v-if="columnLabel=='participation'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <div @click="onChangedSort('participation')" class="table_heading th_cell_4">Participation<span :class="(sortType=='participation_asc')?'fa fa-sort-asc fa-position':(sortType=='participation_desc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" aria-hidden="true"></span></div>
                </div>
            </div>

             <div v-if="columnLabel=='participation_july_june_desc'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <div @click="onChangedSort('participation_july_june_desc')" class="table_heading th_cell_4">Participation (July-June)<span :class="(sortType=='participation_july_june_asc')?'fa fa-sort-asc fa-position':(sortType=='participation_july_june_desc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" aria-hidden="true"></span></div>
                </div>
            </div>

            <div v-if="columnLabel=='location'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <div @click="onChangedSort('location')" class="table_heading th_cell_4">Location<span :class="(sortType=='location_asc')?'fa fa-sort-asc fa-position':(sortType=='location_desc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" aria-hidden="true"></span></div>
                </div>
            </div>

            <div v-if="columnLabel=='custom_field1'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <div @click="onChangedSort('custom_field1')" class="table_heading th_cell_4">{{customField1}}<span :class="(sortType=='custom_field1_asc')?'fa fa-sort-asc fa-position':(sortType=='custom_field1_desc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" class="fa fa-sort fa-position" aria-hidden="true"></span></div>
                </div>
            </div>

            <div v-if="columnLabel=='custom_field2'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <div @click="onChangedSort('custom_field2')" class="table_heading th_cell_4">{{customField2}}<span :class="(sortType=='custom_field2_asc')?'fa fa-sort-asc fa-position':(sortType=='custom_field2_desc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" class="fa fa-sort fa-position" aria-hidden="true"></span></div>
                </div>
            </div>

            <div v-if="columnLabel=='employee_cell_phone'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <!-- <div @click="onChangedSort('employee_cell_phone')" class="table_heading th_cell_4">Cell Phone<span :class="(sortType=='phone_asc')?'fa fa-sort-asc fa-position':(sortType=='phone_desc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" aria-hidden="true"></span></div> -->
                  <div class="table_heading th_cell_4">Cell Phone</div>
                </div>
            </div>

            <div v-if="columnLabel=='member_since'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <div @click="onChangedSort('member_since')" class="table_heading th_cell_4">Member Since<span :class="(sortType=='member_since_asc')?'fa fa-sort-asc fa-position':(sortType=='member_since_desc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" aria-hidden="true"></span></div>
                </div>
            </div>

            <div v-if="columnLabel=='date_of_hire'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <div @click="onChangedSort('date_of_hire')" class="table_heading th_cell_4">Date of Hire<span :class="(sortType=='date_of_hire_asc')?'fa fa-sort-asc fa-position':(sortType=='date_of_hire_desc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" aria-hidden="true"></span></div>
                </div>
            </div>

            <div v-if="columnLabel=='last_offer'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <div @click="onChangedSort('last_offer')" class="table_heading th_cell_4">Last Offer<span :class="(sortType=='last_offer_asc')?'fa fa-sort-asc fa-position':(sortType=='last_offer_desc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" aria-hidden="true"></span></div>
                </div>
            </div>

            <div v-if="columnLabel=='last_assigned'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <div @click="onChangedSort('last_assigned')" class="table_heading th_cell_4">Last Assigned<span :class="(sortType=='last_assigned_asc')?'fa fa-sort-asc fa-position':(sortType=='last_assigned_desc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" aria-hidden="true"></span></div>
                </div>
            </div>

            <div v-if="columnLabel=='last_confirmed'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <div @click="onChangedSort('last_confirmed')" class="table_heading th_cell_4">Last Confirmed<span :class="(sortType=='last_confirmed_asc')?'fa fa-sort-asc fa-position':(sortType=='last_confirmed_desc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" aria-hidden="true"></span></div>
                </div>
            </div>

            <div v-if="columnLabel=='wishlist'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <div @click="onChangedSort('wishlist')" class="table_heading th_cell_4">Wishlist<span :class="(sortType=='wishlist_asc')?'fa fa-sort-asc fa-position':(sortType=='wishlist_desc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" aria-hidden="true"></span></div>
                </div>
            </div>

            <div v-if="columnLabel=='conflicts'" class="table-td-border-right ">
                <div class="calls-table-cell-inner-table">
                  <div @click="onChangedSort('conflicts')" class="table_heading th_cell_5">Conflicts<span :class="(sortType=='conflicts_asc')?'fa fa-sort-asc fa-position':(sortType=='conflicts_desc')?'fa fa-sort-desc fa-position':'fa fa-sort fa-position'" aria-hidden="true"></span></div>
                </div>
            </div>

	</div>
</template>
<script>
    import dateTimeConvert from '../../../timeConvert&Compare';
    import { mapGetters, mapActions } from 'vuex';
    import { global } from '../../../global.js';
    import service from '../../../services.js';
    import { bus } from '../../../main';
    export default {
        props: {

            columnLabel: {
                type: String,
                required: true
            },
            client:{
                type: Object,
                required: true
            },
            sortType: {
                type: String,
                required: true
            }
        },
        data() {
            return {
               columnClass:'',
               customField1: '',
               customField2: '',
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                userID: 'userID',
            })
        },
        methods: {
            onChangedSort(type) {
                // console.log('onChangedSort',type);
                bus.$emit('changeSort', type);
            }
        },
        created() {
            switch(this.columnLabel){
                case "skill_seniority":
                    this.columnClass='calls-table-cell tcell_5'
                    break;
                case "shift_count_total":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "shift_count_ytd":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "declines_total":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "declines_ytd":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "declines_ytd_july_june":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "shifts_this_week":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "employee_cell_phone":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "member_since":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "date_of_hire":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "employee_name":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "conflicts":
                    this.columnClass='calls-table-cell tcell_7'
                    break;
                case "shifts_ytd_july_june":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "location":
                    this.columnClass='calls-table-cell tcell_5'
                    break;
                case "decline_this_week":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "participation":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "participation_july_june_desc":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "last_offer":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "last_assigned":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "last_confirmed":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "wishlist":
                    this.columnClass='calls-table-cell tcell_3'
                    break;
                case "employee_seniority":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "custom_field1":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "custom_field2":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
            }
            this.customField1 = this.client.custom_field_1;
            this.customField2 = this.client.custom_field_2;
        }

    }

</script>
<style scoped>


</style>
